import { HotKeyBox } from '@modules/common/components/HotKeyIcons/HotKeyBox';
import { OptionAltHotkeySymbol } from '@modules/common/components/OptionAltHotkeySymbol';
import { useHotkey } from '@modules/common/hooks';
import { KeyboardReturnRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Stack } from '@mui/material';

interface AddOrEditIntegrationDrawerFooterProps {
  onSubmit: () => void;
  onCancel: () => void;
  buttonText?: string;
  isDisabled: boolean;
  isLoading: boolean;
}

export const AddOrEditIntegrationDrawerFooter = ({
  onSubmit,
  onCancel,
  buttonText = 'Save Changes',
  isDisabled,
  isLoading,
}: AddOrEditIntegrationDrawerFooterProps) => {
  useHotkey({
    hotkey: 'Alt+Enter',
    onHotkey: () => onSubmit(),
    isHotKeyDisabled: isDisabled,
    actionTitle: 'Add or Edit Integration',
  });

  return (
    <Box
      py={2}
      px={3}
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        mt: 'auto',
        bottom: 0,
        position: 'sticky',
        backgroundColor: 'misc.drawer.background',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={2}
      >
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={isDisabled}
          loading={isLoading}
          endIcon={
            !isLoading && (
              <HotKeyBox
                hotkeyDisplay={
                  <Stack direction="row">
                    <OptionAltHotkeySymbol />
                    <KeyboardReturnRounded fontSize="small" />
                  </Stack>
                }
                isDisabled={isDisabled}
              />
            )
          }
        >
          {buttonText}
        </LoadingButton>
      </Stack>
    </Box>
  );
};
